import { Bike, MapPin } from 'lucide-react';

const slides = [
  { id: 'jp', city: 'João Pessoa', line: 'Liberdade sobre duas rodas com a Zeh Motoca.' },
  { id: 'natal', city: 'Natal', line: 'Liberdade sobre duas rodas com a Zeh Motoca.' },
  { id: 'fortaleza', city: 'Fortaleza', line: 'Liberdade sobre duas rodas com a Zeh Motoca.' },
];

export function ClienteCityBanner() {
  return (
    <div className="rounded-2xl border border-zinc-700 bg-zinc-950 overflow-hidden">
      <div className="flex overflow-x-auto snap-x snap-mandatory scroll-smooth gap-0">
        {slides.map((s) => (
          <div
            key={s.id}
            className="min-w-full snap-center flex items-center justify-between gap-4 px-4 py-5 sm:px-6"
          >
            <div className="min-w-0">
              <p className="text-[10px] font-bold uppercase tracking-widest text-amber-400/90 mb-1">
                Locação de motos
              </p>
              <p className="text-xl sm:text-2xl font-bold text-amber-400 flex items-center gap-2">
                <MapPin className="h-6 w-6 shrink-0 hidden sm:block" />
                {s.city}
              </p>
              <p className="text-sm text-zinc-300 mt-1 max-w-md">{s.line}</p>
            </div>
            <Bike className="h-16 w-16 sm:h-20 sm:w-20 text-amber-400/40 shrink-0" aria-hidden />
          </div>
        ))}
      </div>
      <div className="flex justify-center gap-1 pb-3">
        {slides.map((s) => (
          <span key={s.id} className="h-1.5 w-1.5 rounded-full bg-zinc-600" title={s.city} />
        ))}
      </div>
    </div>
  );
}
